import React, { lazy } from "react";

// Lazy load the OurFeaturesSlider component
// const OurFeaturesSlider = lazy(() => import("../ourFeaturesSlider/page"));

const OurFeatures = ({ data, isDesktop }) => {
  return <></>;
};

export default OurFeatures;
